import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import CustomSelect from '../../Components/CustomSelect';
import DatePicker from 'react-datepicker';
import { axiosInstance } from '../../Helpers/axiosInstance';

export default function AccidentPeople({getDate, unGetDate, currentUnit, onClose, addHurtedPeople, editing, editHurtedPeople, base}) {
    const [people, setPeople] = useState([]);
    const [person,setPerson] = useState("");
    const [personObject, setPersonObject] = useState(null);

    const [rang, setRang] = useState("")
    const [position, setPosition] = useState("")
    const [type, setType] = useState()
    const [fullName, setFullName] = useState("")
    const [birthday, setBirthday] = useState("")
    const [conscription, setConscription] = useState("")
    const [milCommissariat, setMilCommissariat] = useState("")
    const [address, setAddress] = useState("")
    const [battalion, setBattalion] = useState("")
    const [company, setCompany] = useState("")
    const [platoon, setPlatoon] = useState("")

    const [responsibility, setResponsibility] = useState("")
    const [hospital, setHospital] = useState("")
    const [hospitalDate, setHospitalDate] = useState(getDate(new Date()))
    const [hospitalTime, setHospitalTime] = useState(null)
    const [doctorsReview, setDoctorsReview] = useState("")
    const [diagnosis, setDiagnosis] = useState("")

    const [result, setResult] = useState("")


    let obj

    useEffect(() => {
        if(editing){
            setPerson(editing.person._id)
            setPersonObject(editing.person)
            setResponsibility(editing.responsibility)
            setHospital(editing.hospital)
            setHospitalDate(editing.hospitalDate)
            setHospitalTime(editing.hospitalTime)
            setDoctorsReview(editing.doctorsReview)
            setDiagnosis(editing.diagnosis)
            setResult(editing.result)
        }
    }, [editing])

    const addPeople = () => {
        addHurtedPeople({
            person: personObject,
            responsibility,
            hospital,
            hospitalDate,
            hospitalTime,
            doctorsReview,
            diagnosis,
            result
        })
        onClose()
    }

    const editPeople = () => {
        editHurtedPeople({
            person: personObject,
            responsibility,
            hospital,
            hospitalDate,
            hospitalTime,
            doctorsReview,
            diagnosis,
            result
        })
        onClose()
    }

    const fetchData = async () => {
        const response = await axiosInstance(`/admin/people/${currentUnit._id}`)
        if(response.data.status){
            if(base){
                setPeople(response.data.data.filter(el => {
                    if(base.base_platoon){return el.platoon.platoon_number === base.base_platoon && el.battalion.battalion_number + " " + el.battalion.battalion_name === base.base_batallion && el.company.company_number === base.base_company }
                    else if(base.base_company){ return el.company.company_number === base.base_company && el.battalion.battalion_number + " " + el.battalion.battalion_name === base.base_batallion }
                    else if(base.base_battalion){ return el.battalion.battalion_number + " " + el.battalion.battalion_name === base.base_batallion }
                }));
            }else{
                setPeople(response.data.data)
            }
        };
    }

    useEffect(() => {
        if(person && people.length){
            setPersonObject(people.find(el => el._id === person))
        }
    }, [person, people])

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if(personObject){
            obj = {
                    rang: `${rang} ${type === "haveTo" ? "" : "(Պ)"}` ,
                    full_name: fullName,
                    conscription,
                    birthday,
                    mil_commissariat: milCommissariat,
                    address,
                    subvision: `${personObject.battalion.battalion_number} ${personObject.battalion.battalion_name} ${personObject.company.company_number} ${personObject.platoon.platoon_number}`,
                    position,
            }
        }
    }, [person,personObject])

    useEffect(() => {
        if(personObject){
            setRang(personObject.rang)
            setPosition(personObject.position)
            setFullName(personObject.full_name)
            setBirthday(personObject.birthday.slice(0, 10))
            setConscription(personObject.conscription)
            setMilCommissariat(personObject.mil_commissariat)
            setAddress(personObject.address)
            setType(personObject.type)
            setBattalion(personObject.battalion.battalion_number + " " + personObject.battalion.battalion_name)
            setCompany(personObject.company.company_number)
            setPlatoon(personObject.platoon.platoon_number)
            setType(personObject.type)
        }else{
            setRang("")
            setPosition("")
            setFullName("")
            setBirthday("")
            setConscription("")
            setMilCommissariat("")
            setAddress("")
            setType("haveTo")
            setBattalion("")
            setCompany("")
            setPlatoon("")
        }
    }, [personObject])


  return (
    <div className='fixed w-screen h-screen bg-black/40 top-0 left-0 flex justify-center items-center z-20'>
        <div className='max-w-full max-h-full bg-white rounded-lg p-4 overflow-x-auto' onClick={e => e.stopPropagation()}>
            <h2 className='text-center mb-4'>Տուժած զինծառայողի մասին տեղեկատվություն</h2>
            <div className='grid grid-cols-2 gap-4'>
                <div className='w-full'>
                    <CustomSelect 
                        defaultValueForInput={personObject ? personObject.rang + " " + personObject.full_name + ", " + personObject.mil_commissariat + " Զինկոմիսարիատ" : ""}
                        options={people?.map((el,i) => <option key={i} value={el._id}>{el.rang + " " + el.full_name + ", " + el.mil_commissariat + " Զինկոմիսարիատ"}</option>)}
                        callback={setPerson}
                        label="Ընտրել զինծառայողին"
                    />
                </div>
                <div className='relative '>
                    <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="responsibility">Զինծառայողի պարտականություններ </label>
                    <input type="text" id="responsibility" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={responsibility} onChange={e => setResponsibility(e.target.value)} />
                </div>
            </div>
            <div className='relative border border-gray-500 rounded-md w-1/2 mx-auto p-2 disabled:bg-gray-200 flex items-center my-4'>
                <p className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap">Պատահարի արդյունքում</p>
                <input type='radio' id="hurt" checked={result === "hurt"} onChange={e => setResult("hurt")} />
                <label htmlFor="hurt" className='ml-1 cursor-pointer mr-6'>Վիրավորվել է</label>
                <input type='radio' id="victim" checked={result === "victim"} onChange={e => setResult("victim")} />    
                <label htmlFor="victim" className='ml-1 cursor-pointer'>Զոհվել է</label>
            </div>
            <div className='grid grid-cols-2 gap-4'>
                {result === "hurt" && <div className='relative '>
                    <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="hospital">Բուժհաստատություն</label>
                    <input type="text" id="hospital" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={hospital} onChange={e => setHospital(e.target.value)} />
                </div>}
                {result === "hurt" && <div className='relative flex justify-center items-center border border-gray-500 rounded-md px-1'>
                    <p className='absolute z-10 top-[-0.5rem] left-2 bg-white text-sm px-[4px] text-nowrap'>Բուժ․ հաստ․ ընդունվելու ժամանակը</p>
                        <DatePicker
                            selected={hospitalDate ? unGetDate(hospitalDate) : null}
                            onChange={(date) => setHospitalDate(getDate(date))}
                            locale="hy"
                            dateFormat="dd MMMM yyyy"
                            id="hospital_date"
                            className=" p-2 w-full border-r border-gray-500"
                        />
                        <input type="time" id="hospital_time" className='  p-2 w-full' value={hospitalTime} onChange={e => setHospitalTime(e.target.value)} />
                </div>}
            </div>
            {result === "hurt" && <div className='relative mb-2 mt-4'>
                <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="diagnosis">Ախտորոշում, վիճակ</label>
                <textarea id="diagnosis" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={diagnosis} onChange={e => setDiagnosis(e.target.value)}/>
            </div>}
            {result === "hurt" && <div className='relative my-2'>
                <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="doctorsReview">Վիճակի վատթարացման վերաբերյալ տեղեկություններ</label>
                <textarea id="doctorsReview" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={doctorsReview} onChange={e => setDoctorsReview(e.target.value)}/>
            </div>}
            <div className='grid grid-cols-2 gap-4 justify-center items-center '>
                <button className='mt-4 bg-blue-500 text-white px-4 py-2 rounded-md' onClick={editing ? editPeople : addPeople}>{editing ? "Փոխել" : "Ավելացնել"}</button>
                <button className='mt-4 bg-gray-300 text-white px-4 py-2 rounded-md ' onClick={onClose}>Փակել</button>
            </div>
        </div>
    </div>
  )
}
